module.exports = __webpack_public_path__ + "img/backspace.ba7acdef.svg";